var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLollipop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 246,
    viewBox: "0 0 213 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_206_52)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_206_52",
    maskUnits: "userSpaceOnUse",
    x: -10.2122,
    y: 5.29905,
    width: 218.473,
    height: 244.4,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -10.2122,
    y: 5.29905,
    width: 218.473,
    height: 244.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.514 135.645C125.299 147.539 154.579 140.332 169.414 117.923C185.468 93.6728 178.527 60.8034 153.911 44.5071C129.295 28.2108 96.3255 34.6585 80.2714 58.9086C65.4827 81.2473 70.207 110.9 90.2858 128.175L42.5673 200.255C40.5115 203.36 41.3623 207.544 44.4676 209.599C47.5728 211.655 51.7566 210.804 53.8123 207.699L101.514 135.645Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.514 135.645C125.299 147.539 154.579 140.332 169.414 117.923C185.468 93.6728 178.527 60.8034 153.911 44.5071C129.295 28.2108 96.3255 34.6585 80.2714 58.9086C65.4827 81.2473 70.207 110.9 90.2858 128.175L42.5673 200.255C40.5115 203.36 41.3623 207.544 44.4676 209.599C47.5728 211.655 51.7566 210.804 53.8123 207.699L101.514 135.645Z",
    fill: "#CB37FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.514 135.645L104.645 129.384L99.0995 126.611L95.677 131.781L101.514 135.645ZM90.2858 128.175L96.1227 132.039L99.5293 126.893L94.8511 122.868L90.2858 128.175ZM42.5673 200.255L48.4041 204.119L42.5673 200.255ZM53.8123 207.699L59.6492 211.563L53.8123 207.699ZM163.577 114.059C150.764 133.413 125.377 139.752 104.645 129.384L98.3829 141.905C125.22 155.326 158.393 147.251 175.251 121.787L163.577 114.059ZM150.047 50.3439C171.522 64.561 177.443 93.1144 163.577 114.059L175.251 121.787C193.493 94.2312 185.532 57.0459 157.775 38.6703L150.047 50.3439ZM86.1083 62.7727C99.9739 41.8284 128.572 36.1269 150.047 50.3439L157.775 38.6703C130.018 20.2946 92.6771 27.4887 74.4346 55.0445L86.1083 62.7727ZM94.8511 122.868C77.3497 107.811 73.3355 82.0663 86.1083 62.7727L74.4346 55.0445C57.6299 80.4284 63.0643 113.989 85.7206 133.481L94.8511 122.868ZM48.4041 204.119L96.1227 132.039L84.449 124.31L36.7304 196.391L48.4041 204.119ZM48.3317 203.763C48.45 203.841 48.4825 204 48.4041 204.119L36.7304 196.391C32.5406 202.719 34.2746 211.246 40.6035 215.436L48.3317 203.763ZM47.9755 203.835C48.0538 203.717 48.2133 203.684 48.3317 203.763L40.6035 215.436C46.9323 219.626 55.4593 217.892 59.6492 211.563L47.9755 203.835ZM95.677 131.781L47.9755 203.835L59.6492 211.563L107.351 139.509L95.677 131.781Z",
    fill: "#23F3F3",
    mask: "url(#path-1-outside-1_206_52)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_206_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.42 83.0517C119.823 81.6357 120.374 80.2484 121.073 78.8898C122.061 77.6494 123.183 76.498 124.438 75.4356C125.929 74.6069 127.515 73.9196 129.196 73.3737C131.011 73.1509 132.862 73.1041 134.747 73.2335C136.632 73.7312 138.48 74.4141 140.29 75.2822C141.949 76.5079 143.496 77.8983 144.931 79.4535C146.075 81.2956 147.042 83.2532 147.834 85.3261C148.225 87.5617 148.398 89.8399 148.354 92.1606C147.854 94.4817 147.125 96.7587 146.167 98.9917C144.766 101.048 143.16 102.972 141.348 104.764C139.175 106.214 136.856 107.457 134.389 108.495C131.707 109.063 128.964 109.375 126.16 109.433C123.333 108.957 120.546 108.212 117.8 107.198C115.242 105.664 112.828 103.887 110.559 101.868C108.674 99.421 107.024 96.7976 105.609 93.9975C104.733 90.9347 104.151 87.7923 103.866 84.5704C104.202 81.3025 104.854 78.071 105.822 74.8759C107.407 71.8735 109.283 69.0259 111.448 66.333C114.134 64.0587 117.04 62.0421 120.164 60.2833C123.628 59.1211 127.202 58.2877 130.888 57.7833C134.67 57.9757 138.431 58.5237 142.172 59.4274C145.736 61.0308 149.144 62.9654 152.395 65.2311C155.207 68.0962 157.741 71.2177 159.998 74.5954C161.603 78.3778 162.842 82.2996 163.718 86.3609C163.812 90.5614 163.503 94.7575 162.792 98.9491C161.278 102.98 159.38 106.855 157.098 110.575C154.11 113.84 150.813 116.815 147.208 119.497C143.1 121.485 138.809 123.08 134.335 124.282C129.645 124.638 124.93 124.552 120.19 124.026C115.568 122.616 111.09 120.779 106.756 118.515C102.872 115.457 99.2881 112.048 96.0049 108.288C93.4544 103.945 91.3246 99.382 89.6153 94.5983C88.8278 89.5357 88.5256 84.4214 88.7089 79.2553C89.8779 74.1688 91.5297 69.2143 93.6643 64.3916",
    fill: "#CB37FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.42 83.0517C119.823 81.6357 120.374 80.2484 121.073 78.8898C122.061 77.6494 123.183 76.498 124.438 75.4356C125.929 74.6069 127.515 73.9196 129.196 73.3737C131.011 73.1509 132.862 73.1041 134.747 73.2335C136.632 73.7312 138.48 74.4141 140.29 75.2822C141.949 76.5079 143.496 77.8983 144.931 79.4535C146.075 81.2956 147.042 83.2532 147.834 85.3261C148.225 87.5617 148.398 89.8399 148.354 92.1606C147.854 94.4817 147.125 96.7587 146.167 98.9917C144.766 101.048 143.16 102.972 141.348 104.764C139.175 106.214 136.856 107.457 134.389 108.495C131.707 109.063 128.964 109.375 126.16 109.433C123.333 108.957 120.546 108.212 117.8 107.198C115.242 105.664 112.828 103.887 110.559 101.868C108.674 99.421 107.024 96.7976 105.609 93.9975C104.733 90.9347 104.151 87.7923 103.866 84.5704C104.202 81.3025 104.854 78.071 105.822 74.8759C107.407 71.8735 109.283 69.0259 111.448 66.333C114.134 64.0587 117.04 62.0421 120.164 60.2833C123.628 59.1211 127.202 58.2877 130.888 57.7833C134.67 57.9757 138.431 58.5237 142.172 59.4274C145.736 61.0308 149.144 62.9654 152.395 65.2311C155.207 68.0963 157.741 71.2177 159.998 74.5954C161.603 78.3778 162.842 82.2997 163.718 86.3609C163.812 90.5614 163.503 94.7575 162.792 98.9491C161.278 102.98 159.38 106.855 157.098 110.575C154.11 113.84 150.813 116.815 147.208 119.497C143.1 121.485 138.809 123.08 134.335 124.282C129.645 124.638 124.93 124.552 120.19 124.026C115.568 122.616 111.09 120.779 106.756 118.515C102.872 115.457 99.2881 112.048 96.0049 108.288C93.4544 103.945 91.3246 99.382 89.6153 94.5983C88.8278 89.5357 88.5256 84.4214 88.7089 79.2553C89.8779 74.1688 91.5297 69.2143 93.6643 64.3916",
    stroke: "#23F3F3",
    strokeWidth: 7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_206_52",
    x: 6.61517,
    y: 0.680111,
    width: 206.28,
    height: 244.871,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.9151
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_206_52"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_206_52",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_206_52",
    x: 56.0572,
    y: 25.171,
    width: 140.277,
    height: 131.926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_206_52"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_206_52",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLollipop);
export default __webpack_public_path__ + "static/media/Lollipop.9cd80b3cb7b5f929095759b66808ce98.svg";
export { ForwardRef as ReactComponent };